import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, Redirect } from 'react-router-dom';
import Login from '../Login';
import ProtectedRoute from './ProtectedRoute';
import Dashboard from '../Dashboard';
import Admins from '../Admins';
import Clients from '../Clients';
import Categories from '../Categories';
import Types from '../Types';
import Cards from '../Cards';
import Places from '../Places';
import Reports from '../Reports';
import ClaimBusiness from '../ClaimBusiness';

Router.propTypes = {
  user: PropTypes.object,
};

function Router(props) {
  const { user } = props;

  return (
    <Switch>
      <Route exact path="/" render={() => <Redirect to="/admins" />} />
      <ProtectedRoute path="/dashboard" component={Dashboard} user={user} />
      <ProtectedRoute path="/admins" component={Admins} user={user} />
      <ProtectedRoute path="/clients" component={Clients} user={user} />
      <ProtectedRoute path="/categories" component={Categories} user={user} />
      <ProtectedRoute path="/types" component={Types} user={user} />
      <ProtectedRoute path="/cards" component={Cards} user={user} />
      <ProtectedRoute path="/places" component={Places} user={user} />
      <ProtectedRoute path="/reports" component={Reports} user={user} />
      <ProtectedRoute path="/claim-business/request" component={ClaimBusiness} user={user} />
      <Route exact path="/login" component={Login} user={user} />
    </Switch>
  );
}

export default Router;



// WEBPACK FOOTER //
// ./src/containers/App/Router.js